import React from "react"
import useDebounceQueryParams from "magik-react-hooks/useRouterDebounceQueryParams"
import Column from "../Column/Column"
import {
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core"
import { Delete, Edit } from "@material-ui/icons"
import { Pagination } from "@material-ui/lab"
import { getUserType } from "../../utils"
import { isMobile } from "react-device-detect"

export default function ListUtenti({
  utenti,
  onDelete,
  onUpdate,
  columnProps,
  pagination,
}) {
  const [
    queryParams,
    setQueryParams,
    debQueryParams,
    setDebQueryParams,
  ] = useDebounceQueryParams()
  return (
    <Card>
      <CardHeader title="Utenti" />
      <CardContent>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                {!isMobile && (
                  <Column {...columnProps} field="id">
                    User id
                  </Column>
                )}
                <Column {...columnProps} field="name">
                  Name
                </Column>
                {!isMobile && (
                  <Column {...columnProps} field="email">
                    E-mail
                  </Column>
                )}
                <Column {...columnProps} field="profilo__permessi">
                  Permessi
                </Column>
                <TableCell>Azioni</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {utenti &&
                utenti.map((utente) => (
                  <TableRow key={utente.id}>
                    {!isMobile && <TableCell>{utente.id}</TableCell>}
                    <TableCell>{utente.name}</TableCell>
                    {!isMobile && <TableCell>{utente.email}</TableCell>}
                    <TableCell>
                      {getUserType(utente.profilo.permessi)}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => onUpdate(utente)}
                        aria-label="modifica"
                        title="Modifica utente"
                      >
                        <Edit style={{ color: "orange" }} />
                      </IconButton>
                      <IconButton
                        onClick={() => onDelete(utente)}
                        aria-label="elimina"
                        title="Elimina utente"
                      >
                        <Delete style={{ color: "red" }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
      <Pagination
        style={{ marginTop: 10, display: "flex", justifyContent: "center" }}
        count={pagination.numPages}
        color="primary"
        page={+debQueryParams.page || 1}
        onChange={(e, page) => setQueryParams({ page })}
      />
    </Card>
  )
}
